import "./Style.css";
import { Dashboard, IDashboardProps } from "./Components/Dashboard";
import { useEffect, useState } from "react";

function App() {
  const [date, setDate] = useState(new Date());
  const dashboardProps: IDashboardProps = {
    dateTime: date,
  };

  useEffect(() => {
    window.setTimeout(() => {
      setDate(new Date());
    }, 1000);
  }, [date]);

  return (
    <div>
      <Dashboard {...dashboardProps} />
    </div>
  );
}

export default App;
